import { SIM_HZ } from '../../data/tuning';
import { t } from '../../i18n/es';

/**
 * Seconds left of the bribe with one decimal and a decimal comma (GDD §13.1), rounded up to the tenth so the
 * badge never shows "0,0" while the bribe is active: 252 ticks is "4,2", 1 tick is "0,1".
 */
export function formatBribeSeconds(ticks: number): string {
  const tenths = Math.ceil((Math.max(0, ticks) * 10) / SIM_HZ);
  return `${Math.floor(tenths / 10)},${tenths % 10}`;
}

export interface PowerUpBadge {
  id: 'armor' | 'bribe';
  text: string;
}

/** The power-up badges of the HUD (GDD §13.3, issue #82), read from the core. */
export function powerUpBadges(core: { armor: boolean; bribeRemaining: number }): PowerUpBadge[] {
  const badges: PowerUpBadge[] = [];
  if (core.armor) badges.push({ id: 'armor', text: t('ui.hud.badge.armor') });
  if (core.bribeRemaining > 0) badges.push({ id: 'bribe', text: t('ui.hud.badge.bribe', { seconds: formatBribeSeconds(core.bribeRemaining) }) });
  return badges;
}
